import { MessageSquareText } from "lucide-preact";
import { getL11nString, uiLangIsRtl } from "@/l11n/l11n";

const ActivityPicker = ({ utterance, activityTypes, onActivitySelect, closeModal }) => {
  const isRtl = uiLangIsRtl();
  return (
    <div
      className="modal-content bg-white text-black p-4 text-lg rounded mx-0"
      style={{ maxWidth: "26rem", margin: "0 auto" }}
    >
      <div
        className="mb-4"
        style={{
          lineHeight: 1.4,
          fontSize: `clamp(1rem, 3.75vw, 1.75rem)`,
          fontWeight: 700,
        }}
        dangerouslySetInnerHTML={{ __html: utterance }}
      />
      <div
        className="max-h-120 overflow-y-auto"
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: isRtl ? "flex-end" : "flex-start",
        }}
      >
        {activityTypes.map((replyOption) => (
          <ActivityPickerItem
            key={replyOption.selectionIntent}
            replyOption={replyOption}
            onClick={() => onActivitySelect(replyOption)}
            closeModal={closeModal}
          />
        ))}
      </div>
      <div
        className="mt-4"
        style={{
          lineHeight: 1.4,
          fontSize: "1rem",
          fontWeight: 500,
          fontStyle: "italic",
        }}
      >
        {getL11nString("more_activities_soon")}
      </div>
    </div>
  );
};

const ActivityPickerItem = ({ replyOption, onClick, closeModal }) => {
  const isRtl = uiLangIsRtl();
  return (
    <div
      key={replyOption.selectionIntent}
      className="p-3 border rounded mb-2 last:mb-0 cursor-pointer hover:bg-gray-100 w-full"
      onClick={() => {
        onClick(replyOption);
        closeModal();
      }}
      style={{
        boxSizing: "border-box",
        textAlign: isRtl ? "right" : "left",
        direction: isRtl ? "rtl" : "ltr",
      }}
    >
      <div
        className="flex flex-row items-center"
        style={{ flexDirection: isRtl ? "row-reverse" : "row" }}
      >
        <MessageSquareText className={isRtl ? "mr-2 ml-4" : "ml-2 mr-4"} size={34} />
        <div className="flex flex-col flex-1">
          <div className={`font-semibold ${isRtl ? "text-right" : "text-left"}`}>
            {replyOption.title}
          </div>
          <div className={`text-sm text-gray-600 ${isRtl ? "text-right" : "text-left"}`}>
            {replyOption.subtitle}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ActivityPicker;
